import SchoolHero from './SchoolHero'


export default SchoolHero
